import { Switch } from '@progress/kendo-react-inputs';
import React, { useContext, useEffect, useState } from 'react';
import * as Events from '../../Context/Pricing/Events';
import { PricingContext } from '../../Context/Pricing/PricingContext';
import Scrollable from '../Shared/Edit/Scrollable';
import { Free } from '../Shared/Subscription/SubscriptionInfo';
import ComparePlanTable from './ComparePlanTable';
import FAQ from './FAQ';
import PriceList from './PriceList';
import SeatChangeInput from './SeatChangeInput';
import { useTranslation } from 'react-i18next';

function PriceSelector() {

    const { state, dispatch } = useContext(PricingContext);
    const [selectedPlan, setSelectedPlan] = useState({});

    const { t } = useTranslation("payment/price_selector");

    useEffect(() => {
        if (state.selectedPlan && state.selectedPlan.stripeProductId) {
            const selectedPlan = state.subscriptions.find(subscription => (
                subscription.subscriptionName.trim().toLowerCase() === state.selectedPlan.name.trim().toLowerCase()
            ));
            setSelectedPlan(selectedPlan);
        }
    }, [state.selectedPlan])

    function setNumberOfSeatsTo2() {
        const { currentOrganization } = state;
        const requiredSeatChange = 2 - currentOrganization.numSeats;
        dispatch({
            type: Events.NUM_SEATS_CHANGED,
            payload: requiredSeatChange
        })
    }

    function userHasSelectedFreePlan() {
        return selectedPlan && selectedPlan.monthlySeatPrice === "0" && selectedPlan.annuallySeatPrice === "0";
    }

    return (
        
            <div className='container h-100 py-5'>
                <div className='row'>
                    <div className='col-12 pb-4 text-center '>
                        <h2 style={{ color: "#212121", fontWeight: "500", fontSize:"24px" }}>
                            { t("title") }
                        </h2>
                        <p style={{ color: "#888EA1" }} className="mt-2 font-size-2 font-weight-2">
                            {t("thank_you_message")}
                            {" "}
                            <span style={{color:"#212121"}}>
                                { state.currentSubscription?.subscriptionName }
                                -
                                { 
                                    state.currentSubscription.subscriptionName === "Free" ||
                                    state.currentSubscriptionStripeData?.plan?.interval === "month"
                                    ? t("monthly") : t("annually")
                                }
                            </span>
                            {" "}
                            {t("plan")}
                        </p>
                        {/* {
                            <span style={{color:"#212121"}}>
                                { state.currentSubscription?.subscriptionName }
                                -
                                { state.currentSubscription?.plan?.interval === "month" ? "Monthly" : "Annual" }
                            </span>{" "}
                            plan
                        </h5>
                        {
                            state.currentSubscription.id && state.currentSubscription.subscriptionName !== "Free" &&
                            <p>
                                Change plan or downgrade to
                                <button
                                    onClick={() => {
                                        dispatch({
                                            type: Events.PRICE_SELECTED,
                                            payload: Free
                                        })
                                        setNumberOfSeatsTo2();
                                    }}
                                    className='btn btn-link'>Free Plan</button>
                            </p>
                        } */}
                    </div>
                </div>
            <div className='text-center p-2 d-flex justify-content-center'>
            <span style={{position:"relative", left:"10%"}}><i class="fa-regular fa-arrow-turn-up arrow-bill"></i><span className="py-2 px-3 annual-billing "><span></span>
                {t("2_month_free")}
            </span></span></div>
                <div className='row'>
                   
                    <div className='col-12 px-0'>
                        <div className='w-100 py-4 d-flex justify-content-center align-items-center'>
                            <div className='mx-3 billing-price px-4 font-size-0'>
                                <span className='billing-price-monthly'>
                                    {t("monthly")}
                                </span>
                                <Switch
                                    size="small"
                                    className="billing-switch mx-4"
                                    checked={state.interval === "annually"}
                                    value={state.interval === "annually"}
                                    onChange={() => {
                                        dispatch({
                                            type: Events.INTERVAL_CHANGED
                                        })
                                    }}
                                />
                                <span className='billing-price-annual'>
                                    {t("yearly")}
                                </span>
                            </div>
                        </div>
                        <PriceList
                            numberOfSeats={state.numSeats}
                            interval={state.interval}
                            onSelect={(plan) => setSelectedPlan(plan)} />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-12 ps-0'>
                        <ComparePlanTable />
                    </div>
                </div>
            <div className="h-25 d-flex justify-content-center flex-column align-items-center faq-heading pt-5 mt-4">
                <h3>
                    {t("frequently_asked_questions")}
                </h3>
                <div className="border-faq mt-4"></div>
            </div>

            <div className="w-100 d-flex justify-content-center flex-column align-items-center faq pe-3">
                <div className="w-101 my-3 faq-shadow">
                    <FAQ />
                </div>
            </div>
        </div>
    );
}

export default PriceSelector;